import { IChatGroup } from '../../../../../../rest/effects/chats/group/types';

export const getChatGroupInitialState = (): IChatGroup => ({
});
